import React from 'react';
import { motion } from 'framer-motion';
import { workbooks } from '../data/content';
export function WorkbooksSection() {
  return <section className="w-full bg-paper px-5 py-12 sm:py-20" data-id="element-264" data-mp="343f6zsccnqx7">
      <div className="mx-auto max-w-5xl" data-id="element-265" data-mp="2zbovvk5l8z4q">
        <div className="mx-auto max-w-2xl text-center" data-id="element-266" data-mp="2zadqxh0eplc1">
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-267" data-mp="2udvo4momzx2c">
            5 Master Workbooks
          </h2>
          <p className="mt-3 text-sm text-ink/70 sm:text-base" data-id="element-268" data-mp="2qctjtrfv4uti">
            Evidence-based content for every core area of High School Chemistry
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:gap-6 md:grid-cols-2" data-id="element-269" data-mp="2ge43i33m7ifd">
          {workbooks.map((workbook, i) => <motion.article key={workbook.number} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.45,
          delay: i % 2 * 0.08
        }} className="flex gap-4 rounded-2xl border border-cobalt/25 bg-white p-5 shadow-sm shadow-cobalt/5 sm:gap-6 sm:p-7" data-id="element-270" data-mp="2bfsu1th8f9xo" data-mpi={i}>
              <div className="flex min-w-0 flex-1" data-id="element-271" data-mp="200ek1z0gcyfn">
                <div className="flex flex-col" data-id="element-272" data-mp="1l6jr62gozjq3">
                  <span className="font-serif-display text-3xl font-bold leading-none text-cobalt sm:text-4xl" data-id="element-273" data-mp="1l7uww7tp71ju">
                    {workbook.number}
                  </span>
                  <h3 className="mt-3 text-base font-bold leading-snug text-ink sm:text-lg" data-id="element-274" data-mp="2duxr4nrccq4a">
                    {workbook.title}
                  </h3>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-ink/70" data-id="element-275" data-mp="244w4m0emzfrh">
                    {workbook.description}
                  </p>
                  <span className="mt-5 inline-block w-fit rounded-full bg-cobalt/10 px-3 py-1 text-xs font-medium text-cobalt-deep" data-id="element-276" data-mp="291miqi6vs1a9">
                    {workbook.tag}
                  </span>
                </div>
              </div>
              <div className="shrink-0 self-start rounded-xl bg-cobalt/10 p-1.5" data-id="element-277" data-mp="3bfqouozxzhxp">
                <img src={workbook.coverImage} alt={`Volume ${workbook.number} box mockup: ${workbook.title}`} loading="lazy" className="block h-[110px] w-[110px] rounded-lg object-contain sm:h-[150px] sm:w-[150px]" data-id="element-278" data-mp="3bdctef1co3pm" />
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}